import React, { Component } from "react";
import "./Footer.css";
import version from "../../../package.json"

export default class Footer extends Component {
  render() {
    const { footer: footerLabels } = window["labels"];
    return (
      <div className="footer">
        <div className="text">{footerLabels.label}{version.version}</div>
        <div className="byNuxiba1">
          <img alt="" src={process.env.PUBLIC_URL + "/pwd_by_nuxiba.svg"}></img>
        </div>
      </div>
    );
  }
}
